import {getLocalStorageObject} from '@/utils'

/**
 * 判断是否拥有权限
 * @param {string|string[]} permission 权限标识
 */
export function checkPermi(permission) {
  const permissions = getLocalStorageObject('permissions') || []
  const list = Array.isArray(permission) ? permission : [permission]
  return list.some(p => permissions.includes(p))
}

/**
 * hasPerm 权限指令
 * 无权限时隐藏元素（不删除 DOM，避免破坏 Vue 虚拟 DOM 导致 emitsOptions 报错）
 */
export const hasPermi = {
  install(Vue) {
    Vue.directive('hasPermi', {
      mounted(el, binding) {
        if (!checkPermi(binding.value)) {
          el.style.display = 'none'
          el.setAttribute('aria-hidden', 'true')
        }
      }
    })
  }
}
export default hasPermi
